import React from 'react'
import { Col, RadioButton, Radio, Tooltip } from 'core/components/ui'
import PropTypes from 'prop-types'
import { useIntl, FormattedMessage } from 'react-intl'
import { InputWrapper, InterTitle, IconStyled } from '../../styled'

const FormItem = ({ vehicle, setTradeIn, tradeIn }) => {
  const intl = useIntl()
  const { historical } = vehicle
  const handleChange = value => {
    const extendedVehicle = {
      ...vehicle,
      historical: { ...vehicle.historical, imported: Number(value) }
    }
    setTradeIn({
      ...tradeIn,
      vehicle: extendedVehicle
    })
  }

  return (
    <Col xs={{ span: 24 }} sm={{ span: 24 }} lg={{ span: 12 }}>
      <InterTitle>
        <FormattedMessage id="tradeIn-historical-question-2-label" />
        <Tooltip
          overlayClassName="globaldealer-tooltip-information"
          title={intl.formatMessage({ id: 'tradeIn-historical-question-2-tooltip' })}
        >
          <IconStyled type="info-circle" style={{ fontSize: '18px' }} />
        </Tooltip>
      </InterTitle>
      <InputWrapper type="flex">
        <Col span={24}>
          <Radio.Group
            buttonStyle="solid"
            value={historical && historical.imported}
            onChange={e => handleChange(e.target.value)}
          >
            <RadioButton value={1}>
              <FormattedMessage id="tradeIn-historical-question-2-reply-1" />
            </RadioButton>
            <RadioButton value={0}>
              <FormattedMessage id="tradeIn-historical-question-2-reply-2" />
            </RadioButton>
            <RadioButton value={2}>
              <FormattedMessage id="tradeIn-historical-question-2-reply-3" />
            </RadioButton>
          </Radio.Group>
        </Col>
      </InputWrapper>
    </Col>
  )
}

FormItem.propTypes = {
  vehicle: PropTypes.shape().isRequired,
  setTradeIn: PropTypes.func.isRequired,
  tradeIn: PropTypes.any.isRequired
}

export default { FormItem }
